export default __webpack_public_path__ + "static/media/carta_seleciona_03.b374325f.mp3";